import { Close } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useState } from 'react';
import { defaultUserDataPrompt } from '../../../constants/agentConstants';
import { transformUserDataPrompt } from '../../../helpers/agentHelper';
import { useTranslation } from '../../../hooks/useTranslation';
import { TranslationKey } from '../../../types/i18n';
import StyledButton from './StyledButton';
import StyledFormSettingsPreview from './StyledFormSettingsPreview';
import StyledUserDataPromptItem from './StyledUserDataPromptItem';

const userDataFieldLabels: Record<string, TranslationKey> = {
  name: 'Name',
  email: 'Email',
  phone: 'Phone',
  company: 'Company',
};

const userDataFieldPlaceholders: Record<string, TranslationKey> = {
  name: 'Enter your name',
  company: 'Enter your company name',
};

interface FormSettingsPreviewProps {
  user_data_prompt_title?: string; // form title
  user_data_prompt_button?: string; // form button label
  user_data_prompt?: string[]; // form user data
  disclaimerHtml?: string; // disclaimer content
}

const FormSettingsPreview: React.FC<FormSettingsPreviewProps> = ({
  user_data_prompt_title,
  user_data_prompt_button,
  user_data_prompt,
  disclaimerHtml,
}) => {
  const { t } = useTranslation();
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  const userDataPromptItems =
    user_data_prompt && user_data_prompt?.length > 0
      ? transformUserDataPrompt(user_data_prompt)
      : defaultUserDataPrompt;

  return (
    <StyledFormSettingsPreview>
      <h3>{user_data_prompt_title || t('Before we start')}</h3>
      {userDataPromptItems?.map(item => {
        const labelKey = userDataFieldLabels[item.id];
        const placeholderKey = userDataFieldPlaceholders[item.id];
        return (
          <StyledUserDataPromptItem key={item.id}>
            <label>{labelKey ? t(labelKey) : item.label}</label>
            <input
              id={item.id}
              type={item.input_type}
              placeholder={
                placeholderKey ? t(placeholderKey) : item.placeholder
              }
            />
          </StyledUserDataPromptItem>
        );
      })}
      <StyledButton onClick={e => e.preventDefault()}>
        {user_data_prompt_button || t('Start to chat')}
      </StyledButton>
      <p
        style={{
          textAlign: 'center',
          fontSize: '11px',
          color: '#6b7280',
          marginTop: '16px',
        }}
      >
        <span
          style={{
            cursor: disclaimerHtml ? 'pointer' : 'default',
            textDecoration: disclaimerHtml ? 'underline' : 'none',
          }}
          onClick={() => {
            if (disclaimerHtml) {
              setShowDisclaimer(prev => !prev);
            }
          }}
        >
          {t('Disclaimer')}
        </span>
      </p>
      {showDisclaimer && (
        <div
          onClick={() => setShowDisclaimer(false)}
          style={{ position: 'absolute', inset: 0, zIndex: 1 }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              position: 'absolute',
              inset: 0,
              backgroundColor: '#fff',
              overflowY: 'auto',
              padding: '18px',
              width: '80%',
              height: '80%',
              borderRadius: '20px',
              boxShadow: 'rgba(0, 0, 0, 0.2) 0px 0px 20px',
              margin: '5% auto',
            }}
          >
            <IconButton
              onClick={() => setShowDisclaimer(false)}
              aria-label={t('Close disclaimer')}
              size="small"
              sx={{ position: 'absolute', top: 8, right: 8 }}
            >
              <Close fontSize="small" />
            </IconButton>
            <div
              style={{ fontSize: '14px', lineHeight: '1.6' }}
              dangerouslySetInnerHTML={{ __html: disclaimerHtml || '' }}
            />
          </div>
        </div>
      )}
    </StyledFormSettingsPreview>
  );
};

export default FormSettingsPreview;
